var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var priceValue = function (f_sellout, price, cnt_stock, seller, domain) {
    var response = {
        isShow: false,
        price: price,
        statusText: ''
    };
    if (f_sellout === 2 || f_sellout === 12) {
        response.statusText = domain === 'minishop' ? '-' : '단종된 상품';
        return response;
    }
    else if (f_sellout === 1 || f_sellout === 11 || price === 0 || !seller) {
        response.statusText = domain === 'minishop' ? '일시품절' : '가격비교예정';
        return response;
    }
    else if (cnt_stock === 0) {
        response.statusText = '일시품절';
        return response;
    }
    else if (isPrice(f_sellout, price, cnt_stock, seller)) {
        response = __assign(__assign({}, response), { isShow: true });
        return response;
    }
};
export var isPrice = function (f_sellout, price, cnt_stock, seller) {
    return f_sellout === 0 && cnt_stock > 0 && price !== 0 && seller !== 0;
};



//////////////////
// WEBPACK FOOTER
// ./src/detail/utils/priceValue.ts
// module id = 272
// module chunks = 0